export function isNum(val: any): boolean {
  return typeof val === 'number' && !isNaN(val);
}

export function toStr(num: number): string | undefined {
  try {
    if (isNum(num)) {
      let str = String(num);
      return str;
    } else {
      throw new Error(`Argument must be number, ${num}`);
    }
  } catch (error) {
    throw error;
  }
}